module.exports = __webpack_public_path__ + "zhengpianActive.94aa61d7.png";